import React from 'react';
import { Link } from 'react-router-dom';
import { Facebook, Instagram, Linkedin, Mail } from 'lucide-react';
import { contactInfo, socialLinks } from '../data/mockData';

const Footer = () => {
  return (
    <footer className="bg-cream py-16">
      <div className="container mx-auto px-6 lg:px-12">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-12 mb-12">
          {/* Logo and Description */}
          <div>
            <Link to="/" className="inline-block mb-6">
              <img
                src="/assets/MG Logo.png"
                alt="Hon Maryka Groenewald MLC"
                className="h-16"
              />
            </Link>
            <p className="text-gray-600 text-sm leading-relaxed max-w-sm">
              Inaugural Australian Christians MP for the Legislative Council in Western Australia. 
              Fighting for life, faith, family and freedom.
            </p>
            {/* Social Links */}
            <div className="flex items-center space-x-4 mt-6">
              <a
                href={socialLinks.facebook}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-navy hover:bg-gold hover:text-white transition-colors"
                aria-label="Facebook"
              >
                <Facebook size={18} />
              </a>
              <a
                href={socialLinks.instagram}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-navy hover:bg-gold hover:text-white transition-colors"
                aria-label="Instagram"
              >
                <Instagram size={18} />
              </a>
              <a
                href={socialLinks.linkedin}
                target="_blank"
                rel="noopener noreferrer"
                className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-navy hover:bg-gold hover:text-white transition-colors"
                aria-label="LinkedIn"
              >
                <Linkedin size={18} />
              </a>
              <a
                href={`mailto:${contactInfo.email}`}
                className="w-10 h-10 rounded-full bg-white flex items-center justify-center text-navy hover:bg-gold hover:text-white transition-colors"
                aria-label="Email"
              >
                <Mail size={18} />
              </a>
            </div>
          </div>

          {/* Navigation */}
          <div>
            <h3 className="text-sm font-bold tracking-wider text-gray-400 uppercase mb-6">
              NAVIGATION
            </h3>
            <ul className="space-y-3">
              <li>
                <Link
                  to="/"
                  className="text-navy hover:text-gold transition-colors font-medium"
                >
                  Home
                </Link>
              </li>
              <li>
                <Link
                  to="/about"
                  className="text-navy hover:text-gold transition-colors font-medium"
                >
                  About Maryka
                </Link>
              </li>
              <li>
                <Link
                  to="/policies"
                  className="text-navy hover:text-gold transition-colors font-medium"
                >
                  Policies
                </Link>
              </li>
              <li>
                <Link
                  to="/media"
                  className="text-navy hover:text-gold transition-colors font-medium"
                >
                  Media
                </Link>
              </li>
              <li>
                <Link
                  to="/newsletter"
                  className="text-navy hover:text-gold transition-colors font-medium"
                >
                  Newsletter
                </Link>
              </li>
              <li>
                <Link
                  to="/contact"
                  className="text-navy hover:text-gold transition-colors font-medium"
                >
                  Contact
                </Link>
              </li>
            </ul>
          </div>

          {/* Contact */}
          <div>
            <h3 className="text-sm font-bold tracking-wider text-gray-400 uppercase mb-6">
              CONTACT
            </h3>
            <div className="space-y-4 text-navy">
              <p className="text-sm leading-relaxed whitespace-pre-line font-medium">
                {contactInfo.address}
              </p>
              <a
                href={`mailto:${contactInfo.email}`}
                className="text-sm hover:text-gold transition-colors inline-block font-medium"
              >
                {contactInfo.email}
              </a>
            </div>
          </div>
        </div>

        {/* Copyright */}
        <div className="border-t border-gray-300 pt-8">
          <p className="text-center text-xs text-gray-400 uppercase tracking-wider">
            © {new Date().getFullYear()} HON MARYKA GROENEWALD MLC. AUTHORISED BY MARYKA GROENEWALD, PERTH.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
